import { TbDatabaseOff } from "react-icons/tb";

const NotFoundDataUI = ({ message = "No records found", onClearSearch, onCreateNew }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center py-5"
      style={{ minHeight: "180px" }}
    >
      {/* Icon bubble */}
      <div
        style={{
          width: "64px",
          height: "64px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #e8f0fe 0%, #f1f5ff 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "16px",
          boxShadow: "0 4px 14px rgba(59, 89, 152, 0.12)",
        }}
      >
        <TbDatabaseOff size={28} style={{ color: "#3b5998", opacity: 0.75 }} />
      </div>

      {/* Heading */}
      <p
        style={{
          fontSize: "15px",
          fontWeight: 700,
          color: "#1e293b",
          marginBottom: "6px",
          letterSpacing: "0.2px",
        }}
      >
        {message}
      </p>

      {/* Sub-text */}
      <p
        style={{
          fontSize: "13px",
          color: "#94a3b8",
          marginBottom: 0,
          letterSpacing: "0.1px",
        }}
      >
        Try adjusting your filters or search criteria.
      </p>

      {/* Action Buttons */}
      {(onClearSearch || onCreateNew) && (
        <div className="d-flex gap-3 mt-4">
          {onClearSearch && (
            <button 
              className="btn btn-outline-secondary px-4 py-2 rounded-pill fw-bold" 
              onClick={onClearSearch}
            >
              Clear Search
            </button>
          )}
          {onCreateNew && (
            <button 
              className="btn btn-primary px-4 py-2 rounded-pill shadow-sm fw-bold" 
              onClick={onCreateNew}
            >
              Create New
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default NotFoundDataUI;
